export default __webpack_public_path__ + "static/media/warning.535e86b0.svg";